import { ACTIVECART_BESTCOUPON_GET_SUCCESS } from '../actionTypes/ActiveCartReminderActionTypes';

const activeCartBestCouponReducer = function activeCartBestCouponReducer(state = {}, action) {
    switch (action.type) {
        case ACTIVECART_BESTCOUPON_GET_SUCCESS: {
            return action.coupons;
        }
        default:
            return state;
    }
};

activeCartBestCouponReducer.reducerName = 'activeCartBestCoupon';

export default activeCartBestCouponReducer;
